mutation DeleteRestreamDestination($contentId: ID!, $id: ID!) {
  deleteRestreamDestination(contentId: $contentId, id: $id) {
    id
  }
}
